/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerMarginReportQuery($customerId: ID!, $endDate: DateTime!, $startDate: DateTime!) {
  CustomerMarginReport(customerId: $customerId, endDate: $endDate, startDate: $startDate) {
    id,
    status,
    message,
    _report
     marginTotals {
      totalCost
      totalMargin
      totalRevenue
    }
  }
}
`
